import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Link2, Copy, Check } from 'lucide-react';
import { toast } from 'sonner';
import { ROLE_COLORS, ROLE_LABELS } from './CommunitySidebar';

const InvitesTab = ({ invites }) => {
  const [copiedCode, setCopiedCode] = useState(null);

  const copyInviteCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopiedCode(code);
    toast.success('Invite code copied!');
    setTimeout(() => setCopiedCode(null), 2000);
  };

  if (invites.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <Link2 className="w-8 h-8 mx-auto mb-2 opacity-50" />
        <p>No active invite codes</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {invites.map((invite) => (
        <div
          key={invite.code}
          className="flex items-center justify-between p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50"
          data-testid={`invite-item-${invite.code}`}
        >
          <div className="flex items-center gap-4">
            <code className="px-3 py-1 bg-slate-200 dark:bg-slate-700 rounded font-mono text-lg">
              {invite.code}
            </code>
            <div>
              <Badge className={ROLE_COLORS[invite.role]}>
                {ROLE_LABELS[invite.role]}
              </Badge>
              <p className="text-xs text-muted-foreground mt-1">
                Uses: {invite.uses}{invite.max_uses ? ` / ${invite.max_uses}` : ' (unlimited)'}
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => copyInviteCode(invite.code)}
            data-testid={`copy-invite-${invite.code}`}
          >
            {copiedCode === invite.code ? (
              <Check className="w-4 h-4 text-green-500" />
            ) : (
              <Copy className="w-4 h-4" />
            )}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default InvitesTab;
